import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SkuService {
  refreshDetails = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  getAll(params: any): any {
    return this.http.get(`${environment.apiStock}/SKU/GetAllWithPagination`, { params });
  }

  saveRecord(data: any, recordId: number) {
    if (recordId) {
      return this.http.put(`${environment.apiStock}/SKU/UpdateSKU`, data);
    } else {
      return this.http.post(`${environment.apiStock}/SKU/CreateSKU`, data);
    }
  }

  filterDefinitionSKU() {
    return this.http.get(`${environment.apiStock}/SKU/FilterDefinitionSKU`);
  }

  getDetails(id: number) {
    return this.http.get(`${environment.apiStock}/SKU/GetSKUDetails/${id}`);
  }

  getSkuDefinition(id: number, recordId: number) {
    if (recordId) {
      return this.http.get(`${environment.apiStock}/SKU/SKUDefinitionForUpdate/${recordId}/${id}`);
    } else {
      return this.http.get(`${environment.apiStock}/SKU/SKUDefinition/${id}`);
    }
  }

  importFile(data: any) {
    return this.http.post(`${environment.apiStock}/SKU/ImportFile`, data);
  }

  importImage(data: any) {
    return this.http.post(`${environment.apiStock}/SKU/ImportImage`, data);
  }

  deleteRecord(data: any) {
    return this.http.post(`${environment.apiStock}/SKU/DeleteSKU`, data);
  }

  isActiveSKU(id: number) {
    return this.http.post(`${environment.apiStock}/SKU/IsActiveSKU/${id}`, null);
  }

  getHazardsBySKUId(id: number) {
    return this.http.get(`${environment.apiStock}/SKU/GetHazardsBySKUId/${id}`);
  }

  deleteFile(FileId: number) {
    return this.http.get(`${environment.apiStock}/SKU/DeleteFile/${FileId}`);
  }

  deleteImage(SKUId: number) {
    return this.http.get(`${environment.apiStock}/SKU/DeleteImage?SKUId=${SKUId}`);
  }

  getSKUGroup(OrgId: number) {
    return this.http.get(`${environment.apiStock}/SKU/GetSKUGroup/${OrgId}`);
  }

  getSkuforOutbound(params: any) {
    return this.http.get(`${environment.apiStock}/SKU/GetSkuforOutbound`, { params });
  }

  getSkuforKitting(OrgId: number) {
    return this.http.get(`${environment.apiStock}/SKU/GetSkuforKitting?OrgId=${OrgId}`);
  }

  importExcelFile(data: any) {
    return this.http.post(`${environment.apiStock}/SKU/ImportExcelFile`, data);
  }

  downloadFile(){
    return this.http.get(`${environment.apiStock}/SKU/DownloadFile`, { responseType: 'blob' });
  }
}
